/** Build the stacked guest identity block (name + optional muted org). */
export function createGuestShellNameText(
  displayName: string,
  organization?: string | null,
): HTMLSpanElement {
  const text = document.createElement('span');
  text.className = 'user-label__text';

  const name = document.createElement('span');
  name.className = 'user-label__name';
  name.textContent = displayName;
  text.append(name);

  const org = organization?.trim();
  if (org) {
    const orgEl = document.createElement('span');
    orgEl.className = 'user-label__org';
    orgEl.textContent = org;
    text.append(orgEl);
  }

  return text;
}

/** Update `#guest-shell-name` and mobile account-menu identity with stacked username / muted organization. */
export function setGuestShellName(displayName: string, organization?: string | null): void {
  const label = document.getElementById('guest-shell-name');
  if (label) {
    label.hidden = false;

    const existing = label.querySelector('.user-label__text');
    const next = createGuestShellNameText(displayName, organization);
    if (existing) {
      existing.replaceWith(next);
    } else {
      label.append(next);
    }
  }

  const accountName = document.getElementById('guest-shell-account-name');
  if (accountName) {
    accountName.replaceChildren(createGuestShellNameText(displayName, organization));
  }

  const accountTriggerLabel = document.querySelector(
    '.app-shell--guest .app-account-menu-trigger .app-menu-trigger__label',
  );
  if (accountTriggerLabel) {
    accountTriggerLabel.textContent = displayName;
  }
}
